// extracted by mini-css-extract-plugin
export default {"header":"Z0DgY"};